import type { ReactNode, ElementType, HTMLAttributes } from 'react';
import styles from './Text.module.css';

type TextVariant = 'display' | 'title' | 'body' | 'meta';

interface TextProps extends HTMLAttributes<HTMLElement> {
  variant?: TextVariant;
  as?: ElementType;
  muted?: boolean;
  children: ReactNode;
}

const variantDefaults: Record<TextVariant, ElementType> = {
  display: 'h1',
  title: 'h2',
  body: 'p',
  meta: 'span',
};

export const Text = ({
  variant = 'body',
  as,
  muted = false,
  children,
  className = '',
  ...props
}: TextProps) => {
  const Component = as || variantDefaults[variant];
  
  const classNames = [
    styles.text,
    styles[variant],
    muted && styles.muted,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Component className={classNames} {...props}>
      {children}
    </Component>
  );
};
